module.exports = __webpack_public_path__ + "static/server-02e51a67ed4fd72622dc1a66e45c1bbd.png";